import { render, staticRenderFns } from "./ItemFileRelations.vue?vue&type=template&id=32ee9fa0&scoped=true&"
import script from "./ItemFileRelations.vue?vue&type=script&lang=js&"
export * from "./ItemFileRelations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ee9fa0",
  null
  
)

export default component.exports